var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 115,
    viewBox: "0 0 110 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4435 101.25C18.3268 102.708 16.1622 104.212 14.6965 106.323C13.2309 108.435 12.5911 111.317 13.7688 113.601L13.7384 113.744C14.631 114.057 15.5893 114.136 16.5211 113.972C17.4528 113.808 18.3267 113.406 19.0583 112.806C20.9215 111.242 21.5058 108.666 21.9811 106.28L23.3871 99.2236L20.4435 101.25Z",
    fill: "#FF9A27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4809 108.366C21.0689 108.678 19.6221 109.005 18.4113 109.796C17.2006 110.587 16.2575 111.954 16.3885 113.395L16.3425 113.462C16.7416 113.815 17.2247 114.059 17.7453 114.17C18.2659 114.281 18.8064 114.257 19.3148 114.099C20.6171 113.677 21.4666 112.457 22.219 111.314L24.4445 107.932L22.4809 108.366Z",
    fill: "#FFB6B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7243 7.20251H11.7789C11.7326 7.20235 11.6882 7.18384 11.6555 7.15104C11.6228 7.11824 11.6045 7.07383 11.6045 7.02752C11.6045 6.98122 11.6228 6.9368 11.6555 6.904C11.6882 6.8712 11.7326 6.8527 11.7789 6.85254H93.7243C93.7706 6.8527 93.8149 6.8712 93.8476 6.904C93.8803 6.9368 93.8986 6.98122 93.8986 7.02752C93.8986 7.07383 93.8803 7.11824 93.8476 7.15104C93.8149 7.18384 93.7706 7.20235 93.7243 7.20251Z",
    fill: "#CACACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3521 4.54398C16.4151 4.54398 17.2769 3.68221 17.2769 2.61916C17.2769 1.55611 16.4151 0.694336 15.3521 0.694336C14.289 0.694336 13.4272 1.55611 13.4272 2.61916C13.4272 3.68221 14.289 4.54398 15.3521 4.54398Z",
    fill: "url(#paint0_linear_4699_3876)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0007 4.54398C23.0638 4.54398 23.9256 3.68221 23.9256 2.61916C23.9256 1.55611 23.0638 0.694336 22.0007 0.694336C20.9377 0.694336 20.0759 1.55611 20.0759 2.61916C20.0759 3.68221 20.9377 4.54398 22.0007 4.54398Z",
    fill: "url(#paint1_linear_4699_3876)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6499 4.54398C29.713 4.54398 30.5747 3.68221 30.5747 2.61916C30.5747 1.55611 29.713 0.694336 28.6499 0.694336C27.5869 0.694336 26.7251 1.55611 26.7251 2.61916C26.7251 3.68221 27.5869 4.54398 28.6499 4.54398Z",
    fill: "url(#paint2_linear_4699_3876)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5596 10.1123H13.592V58.0579H93.5596V10.1123Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9654 35.9065C58.2612 35.9065 60.9328 33.2348 60.9328 29.9391C60.9328 26.6434 58.2612 23.9717 54.9654 23.9717C51.6697 23.9717 48.998 26.6434 48.998 29.9391C48.998 33.2348 51.6697 35.9065 54.9654 35.9065Z",
    fill: "#9E616A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0198 58.0603H50.0569L50.8967 39.1394L51 39.0308L52.4857 37.4629H57.2103L58.9636 39.1602L59.1017 39.2951L62.8325 42.8699L65.0198 58.0603Z",
    fill: "#FF9A27"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1991 58.0586H42.8269C42.7517 50.8178 42.6921 45.3548 42.6921 45.3548L43.2731 45.0013L43.2766 44.9996L49.6547 41.1272L50.9934 38.9521L51.0005 39.0291L51.3942 43.6137C51.3942 43.6137 53.5341 50.5273 54.1991 58.0586Z",
    fill: "url(#paint3_linear_4699_3876)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6729 58.0586H59.5536C59.0128 55.6054 58.7311 53.2693 58.8537 51.3218C59.3506 43.3652 58.2045 38.9521 58.7014 38.9521L58.9639 39.1586L62.0855 41.6242L66.196 43.1308L69.0482 44.1772L69.5451 44.3592V44.5989C69.5469 45.8028 69.5591 51.3935 69.6729 58.0586Z",
    fill: "url(#paint4_linear_4699_3876)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3199 31.8058C49.3199 31.8058 49.8269 30.9154 49.7091 27.9409C49.5912 24.9664 54.1206 26.6487 57.9055 26.365C61.6903 26.0812 60.8891 31.331 60.8891 31.331C60.8891 31.331 61.1622 31.0189 61.7468 28.4852C62.3314 25.9515 61.004 23.4266 61.004 23.4266C60.6131 20.7642 58.5063 21.6175 58.5063 21.6175C59.5209 22.0125 59.326 22.857 59.326 22.857C58.4672 21.3513 56.3603 22.2046 56.3603 22.2046C53.5504 20.4413 50.7026 22.7633 50.7026 22.7633C47.3081 23.5337 49.2989 26.2332 49.2989 26.2332C45.8852 27.9584 49.3199 31.8058 49.3199 31.8058Z",
    fill: "url(#paint5_linear_4699_3876)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5317 58.0581C39.8222 52.2503 40.0444 47.6938 39.9569 47.3421C39.7119 46.3639 43.1679 45.0393 43.2729 45.0008L43.2746 44.999H43.2764L43.9361 45.3542L44.419 58.0581H39.5317Z",
    fill: "url(#paint6_linear_4699_3876)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0527 58.0588H66.9169L65.447 43.5404L66.0525 43.0977C66.0525 43.0977 66.105 43.1099 66.196 43.1309C66.6667 43.2481 68.1856 43.6454 69.0482 44.1773C69.2391 44.2851 69.4077 44.4282 69.5451 44.599C69.6292 44.6996 69.6713 44.8287 69.6624 44.9595C69.6187 45.3707 70.7386 51.1837 72.0527 58.0588Z",
    fill: "url(#paint7_linear_4699_3876)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9654 62.0664H23.6305C23.3754 62.0668 23.1309 62.166 22.9507 62.3421C22.7704 62.5182 22.6692 62.7569 22.6692 63.0058C22.6692 63.2546 22.7704 63.4933 22.9507 63.6695C23.1309 63.8456 23.3754 63.9447 23.6305 63.9451H89.9654C90.092 63.9453 90.2174 63.9212 90.3344 63.8741C90.4514 63.827 90.5577 63.7578 90.6473 63.6705C90.7369 63.5833 90.808 63.4797 90.8565 63.3656C90.905 63.2515 90.9299 63.1293 90.9299 63.0058C90.9299 62.8823 90.905 62.76 90.8565 62.6459C90.808 62.5319 90.7369 62.4282 90.6473 62.341C90.5577 62.2538 90.4514 62.1846 90.3344 62.1375C90.2174 62.0904 90.092 62.0662 89.9654 62.0664Z",
    fill: "#CACACA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9338 62.0664V63.9451H23.6294C23.3746 63.9447 23.1304 63.8456 22.9503 63.6695C22.7703 63.4933 22.6692 63.2546 22.6692 63.0058C22.6692 62.7569 22.7703 62.5182 22.9503 62.3421C23.1304 62.166 23.3746 62.0668 23.6294 62.0664H71.9338Z",
    fill: "url(#paint8_linear_4699_3876)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9327 64.9897C72.9703 64.9897 73.8114 64.1018 73.8114 63.0066C73.8114 61.9113 72.9703 61.0234 71.9327 61.0234C70.8951 61.0234 70.054 61.9113 70.054 63.0066C70.054 64.1018 70.8951 64.9897 71.9327 64.9897Z",
    fill: "url(#paint9_linear_4699_3876)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.694 78.9744C55.9096 78.9744 55.1427 78.7418 54.4905 78.306C53.8383 77.8702 53.3299 77.2508 53.0297 76.526C52.7295 75.8013 52.651 75.0038 52.804 74.2345C52.957 73.4651 53.3348 72.7584 53.8895 72.2037C54.4442 71.649 55.1509 71.2712 55.9202 71.1182C56.6896 70.9652 57.4871 71.0437 58.2118 71.3439C58.9365 71.6441 59.556 72.1525 59.9918 72.8047C60.4276 73.4569 60.6602 74.2238 60.6602 75.0082C60.659 76.0598 60.2408 77.0679 59.4972 77.8114C58.7537 78.555 57.7455 78.9732 56.694 78.9744ZM56.694 71.3471C55.9699 71.3471 55.2621 71.5618 54.66 71.9641C54.0579 72.3664 53.5887 72.9382 53.3116 73.6072C53.0345 74.2762 52.962 75.0123 53.1032 75.7225C53.2445 76.4327 53.5932 77.085 54.1052 77.597C54.6172 78.109 55.2696 78.4577 55.9797 78.599C56.6899 78.7403 57.4261 78.6678 58.0951 78.3907C58.764 78.1136 59.3358 77.6443 59.7381 77.0422C60.1404 76.4402 60.3551 75.7323 60.3551 75.0082C60.354 74.0376 59.9679 73.107 59.2816 72.4206C58.5952 71.7343 57.6646 71.3482 56.694 71.3471Z",
    fill: "#FF9A27"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2771 77.0959C56.2218 77.0959 56.1686 77.0802 56.1295 77.0522C56.0904 77.0243 56.0684 76.9863 56.0684 76.9468V73.0714C56.0681 73.0517 56.0733 73.0322 56.0836 73.0139C56.094 72.9957 56.1093 72.9791 56.1288 72.9651C56.1482 72.9511 56.1713 72.94 56.1967 72.9324C56.2222 72.9248 56.2495 72.9209 56.2771 72.9209C56.3047 72.9209 56.332 72.9248 56.3575 72.9324C56.3829 72.94 56.406 72.9511 56.4255 72.9651C56.4449 72.9791 56.4602 72.9957 56.4706 73.0139C56.4809 73.0322 56.4861 73.0517 56.4858 73.0714V76.9468C56.4858 76.9864 56.4639 77.0243 56.4247 77.0522C56.3856 77.0802 56.3325 77.0959 56.2771 77.0959Z",
    fill: "#FF9A27"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3203 77.0959C57.265 77.0959 57.2119 77.0802 57.1727 77.0522C57.1336 77.0243 57.1116 76.9863 57.1116 76.9468V73.0713C57.1113 73.0516 57.1165 73.0321 57.1269 73.0139C57.1373 72.9956 57.1526 72.979 57.172 72.9651C57.1914 72.9511 57.2145 72.94 57.24 72.9324C57.2654 72.9248 57.2927 72.9209 57.3203 72.9209C57.3479 72.9209 57.3752 72.9248 57.4006 72.9324C57.4261 72.94 57.4492 72.9511 57.4686 72.9651C57.488 72.979 57.5033 72.9956 57.5137 73.0139C57.5241 73.0321 57.5293 73.0516 57.5291 73.0713V76.9468C57.5291 76.9863 57.5071 77.0243 57.4679 77.0522C57.4288 77.0802 57.3757 77.0959 57.3203 77.0959Z",
    fill: "#FF9A27"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5322 75.0082C38.5322 74.2238 38.7648 73.4569 39.2007 72.8047C39.6365 72.1525 40.2559 71.6441 40.9806 71.3439C41.7054 71.0437 42.5028 70.9652 43.2722 71.1182C44.0416 71.2712 44.7483 71.649 45.303 72.2037C45.8577 72.7584 46.2354 73.4651 46.3885 74.2345C46.5415 75.0038 46.4629 75.8013 46.1627 76.526C45.8626 77.2508 45.3542 77.8702 44.702 78.306C44.0497 78.7418 43.2829 78.9744 42.4984 78.9744C41.4469 78.9732 40.4388 78.555 39.6952 77.8114C38.9517 77.0679 38.5334 76.0598 38.5322 75.0082ZM38.8373 75.0082C38.8373 75.7323 39.0521 76.4402 39.4543 77.0422C39.8566 77.6443 40.4284 78.1136 41.0974 78.3907C41.7664 78.6678 42.5025 78.7403 43.2127 78.599C43.9229 78.4578 44.5752 78.1091 45.0873 77.597C45.5993 77.085 45.948 76.4327 46.0892 75.7225C46.2305 75.0123 46.158 74.2762 45.8809 73.6072C45.6038 72.9382 45.1345 72.3664 44.5325 71.9641C43.9304 71.5618 43.2225 71.3471 42.4984 71.3471C41.5278 71.3482 40.5972 71.7343 39.9109 72.4206C39.2245 73.107 38.8384 74.0376 38.8373 75.0082Z",
    fill: "#3F3D56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2538 76.2618C44.2811 76.2618 44.3077 76.2532 44.3294 76.2373C44.3511 76.2213 44.3667 76.199 44.3738 76.1737C44.3808 76.1484 44.379 76.1215 44.3686 76.0973C44.3581 76.0731 44.3396 76.0529 44.3159 76.0398L42.4541 75.0093L44.3159 73.9789C44.3445 73.9631 44.3653 73.9371 44.3738 73.9067C44.3823 73.8762 44.3779 73.8437 44.3614 73.8164C44.3449 73.789 44.3178 73.7691 44.286 73.7609C44.2542 73.7527 44.2203 73.757 44.1918 73.7728L42.1438 74.9063C42.125 74.9167 42.1093 74.9317 42.0984 74.9498C42.0875 74.9679 42.0818 74.9884 42.0818 75.0093C42.0818 75.0302 42.0875 75.0507 42.0984 75.0688C42.1093 75.0869 42.125 75.102 42.1438 75.1124L44.1918 76.2459C44.2106 76.2563 44.232 76.2618 44.2538 76.2618Z",
    fill: "url(#paint10_linear_4699_3876)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5599 76.8874C41.5876 76.8874 41.6142 76.8732 41.6337 76.848C41.6533 76.8229 41.6643 76.7887 41.6643 76.7531V73.2641C41.6643 73.2285 41.6533 73.1944 41.6337 73.1692C41.6142 73.144 41.5876 73.1299 41.5599 73.1299C41.5323 73.1299 41.5057 73.144 41.4861 73.1692C41.4666 73.1944 41.4556 73.2285 41.4556 73.2641V76.7531C41.4556 76.7887 41.4666 76.8229 41.4861 76.848C41.5057 76.8732 41.5323 76.8874 41.5599 76.8874Z",
    fill: "url(#paint11_linear_4699_3876)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8883 78.9744C70.1039 78.9744 69.3371 78.7418 68.6848 78.306C68.0326 77.8702 67.5242 77.2508 67.224 76.526C66.9238 75.8013 66.8453 75.0038 66.9983 74.2345C67.1514 73.4651 67.5291 72.7584 68.0838 72.2037C68.6385 71.649 69.3452 71.2712 70.1146 71.1182C70.8839 70.9652 71.6814 71.0437 72.4061 71.3439C73.1309 71.6441 73.7503 72.1525 74.1861 72.8047C74.6219 73.4569 74.8546 74.2238 74.8546 75.0082C74.8534 76.0598 74.4351 77.0679 73.6916 77.8114C72.948 78.555 71.9399 78.9732 70.8883 78.9744ZM70.8883 71.3471C70.1642 71.3471 69.4564 71.5618 68.8543 71.9641C68.2523 72.3664 67.783 72.9382 67.5059 73.6072C67.2288 74.2762 67.1563 75.0123 67.2976 75.7225C67.4388 76.4327 67.7875 77.085 68.2995 77.597C68.8115 78.109 69.4639 78.4577 70.1741 78.599C70.8843 78.7403 71.6204 78.6678 72.2894 78.3907C72.9584 78.1136 73.5302 77.6443 73.9324 77.0422C74.3347 76.4402 74.5495 75.7323 74.5495 75.0082C74.5483 74.0376 74.1623 73.107 73.4759 72.4206C72.7896 71.7343 71.859 71.3482 70.8883 71.3471Z",
    fill: "url(#paint12_linear_4699_3876)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3437 76.2618C69.3164 76.2618 69.2898 76.2532 69.2681 76.2373C69.2464 76.2213 69.2308 76.199 69.2237 76.1737C69.2166 76.1484 69.2185 76.1215 69.2289 76.0973C69.2394 76.0731 69.2579 76.0529 69.2815 76.0397L71.1434 75.0092L69.2815 73.9787C69.2531 73.9629 69.2324 73.9369 69.224 73.9065C69.2155 73.876 69.22 73.8436 69.2365 73.8164C69.2529 73.7891 69.2799 73.7692 69.3116 73.7609C69.3433 73.7527 69.3771 73.7569 69.4057 73.7726L71.4536 74.9062C71.4725 74.9166 71.4882 74.9316 71.4991 74.9497C71.51 74.9678 71.5157 74.9883 71.5157 75.0092C71.5157 75.0301 71.51 75.0506 71.4991 75.0687C71.4882 75.0868 71.4725 75.1019 71.4536 75.1123L69.4057 76.2459C69.3868 76.2563 69.3655 76.2618 69.3437 76.2618Z",
    fill: "url(#paint13_linear_4699_3876)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0375 76.8874C72.0098 76.8874 71.9833 76.8732 71.9637 76.848C71.9441 76.8229 71.9331 76.7887 71.9331 76.7531V73.2641C71.9331 73.2285 71.9441 73.1944 71.9637 73.1692C71.9833 73.144 72.0098 73.1299 72.0375 73.1299C72.0652 73.1299 72.0917 73.144 72.1113 73.1692C72.1309 73.1944 72.1419 73.2285 72.1419 73.2641V76.7531C72.1419 76.7887 72.1309 76.8229 72.1113 76.848C72.0917 76.8732 72.0652 76.8874 72.0375 76.8874Z",
    fill: "url(#paint14_linear_4699_3876)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59491 77.1811C4.42308 77.009 4.29109 76.8012 4.20822 76.5726C4.12536 76.3439 4.09364 76.0998 4.1153 75.8576C4.13697 75.6153 4.21148 75.3807 4.33361 75.1704C4.45573 74.96 4.62249 74.779 4.82214 74.6401L3.22266 68.9482L6.14947 69.8827L7.21965 75.1445C7.43081 75.4954 7.50592 75.9115 7.43076 76.3141C7.35561 76.7166 7.1354 77.0776 6.81187 77.3286C6.48834 77.5797 6.08395 77.7033 5.67535 77.6761C5.26676 77.6489 4.88233 77.4728 4.59491 77.1811Z",
    fill: "#FFB6B6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44941 48.6749L2.84314 48.0439C2.84314 48.0439 0.968701 49.3314 1.3653 53.3225C1.65825 56.2705 0.732537 57.5207 0.835993 66.089L3.44941 73.936L6.47216 72.3515L4.28524 62.6693L3.44941 48.6749Z",
    fill: "#FF961F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71721 112.358H7.88465L8.91587 103.998L5.7168 103.998L5.71721 112.358Z",
    fill: "#FFB6B6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16479 111.652L9.43325 111.651C10.1547 111.651 10.8467 111.938 11.3568 112.448C11.867 112.958 12.1536 113.65 12.1536 114.372V114.46L5.16494 114.46L5.16479 111.652Z",
    fill: "#2F2E41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0376 111.591L14.189 111.855L16.2301 103.682L13.055 103.293L12.0376 111.591Z",
    fill: "#FFB6B6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.575 110.822L15.8117 111.342C16.5277 111.43 17.1797 111.798 17.624 112.367C18.0682 112.935 18.2684 113.657 18.1807 114.373L18.1699 114.461L11.2332 113.61L11.575 110.822Z",
    fill: "url(#paint15_linear_4699_3876)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59307 69.4961C4.59307 69.4961 0.417888 72.3495 2.50537 80.0732L5.32841 110.053L8.68236 110.029L10.103 95.2363L11.0684 84.8218L14.2943 95.5913L11.641 108.806L15.5571 109.218L20.249 93.8506L17.9864 71.9708L4.59307 69.4961Z",
    fill: "url(#paint16_linear_4699_3876)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6672 47.2342L12.5443 45.5266L6.91431 45.2949L2.84255 48.0441C2.84255 48.0441 2.42225 57.8336 5.17753 66.5539L3.73299 70.1965L18.1763 72.0085L14.6672 47.2342Z",
    fill: "#FFA034"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1151 43.1984C12.7822 43.1984 14.9443 41.0363 14.9443 38.3692C14.9443 35.7021 12.7822 33.54 10.1151 33.54C7.44799 33.54 5.28589 35.7021 5.28589 38.3692C5.28589 41.0363 7.44799 43.1984 10.1151 43.1984Z",
    fill: "#FFB6B6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3832 32.3982H10.31C9.56222 32.1753 8.77271 32.1302 8.00439 32.2663C7.23606 32.4025 6.51016 32.7163 5.88451 33.1826C5.25887 33.6489 4.75079 34.2549 4.40074 34.9522C4.0507 35.6496 3.86836 36.4191 3.86827 37.1994L2.19686 42.715C2.14867 42.874 2.13839 43.0422 2.16684 43.2059C2.1953 43.3696 2.2617 43.5244 2.36072 43.6579C2.45974 43.7914 2.58865 43.8998 2.7371 43.9745C2.88556 44.0492 3.04944 44.0881 3.21563 44.0881H4.03146C4.37308 43.6015 4.52209 43.0055 4.44967 42.4155C4.60138 42.7849 4.70768 43.1714 4.76626 43.5664C4.78517 43.74 4.78158 43.9154 4.75555 44.0881H11.8531C11.899 43.392 11.6684 42.7058 11.2114 42.1787C11.7832 42.75 12.2802 43.3916 12.6904 44.0881H12.8238C13.1061 44.0881 13.3768 43.9759 13.5764 43.7763C13.776 43.5767 13.8882 43.306 13.8882 43.0237V37.6169H16.6019C16.6019 36.9316 16.4669 36.253 16.2047 35.6198C15.9424 34.9866 15.558 34.4113 15.0734 33.9267C14.5888 33.4421 14.0135 33.0577 13.3803 32.7954C12.7472 32.5332 12.0685 32.3982 11.3832 32.3982Z",
    fill: "url(#paint17_linear_4699_3876)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16.757 76.6137C16.5852 76.4416 16.4532 76.2339 16.3703 76.0052C16.2875 75.7765 16.2557 75.5325 16.2774 75.2902C16.2991 75.0479 16.3736 74.8134 16.4957 74.603C16.6178 74.3927 16.7846 74.2117 16.9843 74.0727L15.3848 68.3809L18.3116 69.3153L19.3818 74.5772C19.5929 74.928 19.668 75.3442 19.5929 75.7467C19.5177 76.1492 19.2975 76.5102 18.974 76.7613C18.6504 77.0123 18.2461 77.1359 17.8375 77.1088C17.4289 77.0816 17.0444 76.9054 16.757 76.6137Z",
    fill: "#FFB6B6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8379 48.3114L14.6686 47.2312C14.6686 47.2312 17.5481 46.7236 17.8555 50.56C18.1628 54.3963 18.6056 64.3548 18.6056 64.3548L19.5037 72.7498L16.1708 73.4604L12.3401 61.9803L12.8379 48.3114Z",
    fill: "#FF961F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M91.585 58.8687L97.5128 55.2211C97.5128 55.2211 100.198 52.0372 101.864 51.3113L103.877 53.2372L100.556 57.2407L92.6072 60.7359C92.4952 60.9207 92.3365 61.0727 92.1471 61.1767C91.9577 61.2807 91.7442 61.333 91.5282 61.3282C91.3122 61.3235 91.1012 61.2619 90.9165 61.1497C90.7319 61.0375 90.58 60.8787 90.4762 60.6892C90.3725 60.4996 90.3205 60.2861 90.3254 60.0701C90.3304 59.8541 90.3922 59.6432 90.5046 59.4586C90.617 59.2741 90.7761 59.1224 90.9657 59.0188C91.1554 58.9153 91.3689 58.8635 91.585 58.8687Z",
    fill: "#FFB6B6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5203 99.6881L94.7635 99.688L93.9278 92.9121L96.5205 92.9122L96.5203 99.6881Z",
    fill: "#FFB6B6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9675 99.1142L96.4731 99.1142L94.5426 98.3291L93.508 99.114H93.5078C92.9231 99.1141 92.3623 99.3464 91.9489 99.7598C91.5354 100.173 91.3031 100.734 91.3031 101.319V101.39L96.9674 101.391L96.9675 99.1142Z",
    fill: "#2F2E41"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.029 98.0351L107.365 98.5984L104.4 92.4487L106.856 91.6172L109.029 98.0351Z",
    fill: "#FFB6B6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M109.27 97.3467L108.802 97.5053L106.721 97.3808L105.993 98.4562L105.993 98.4562C105.439 98.6438 104.983 99.0437 104.724 99.5679C104.465 100.092 104.424 100.698 104.612 101.252L104.635 101.319L110 99.5028L109.27 97.3467Z",
    fill: "#2F2E41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106.993 70.5021C106.993 70.5021 107.198 72.9636 106.685 75.3226C106.172 77.6815 105.069 85.5121 105.069 85.5121C107.304 89.1861 108.6 92.8015 108.844 96.4612L105.698 96.7129L101.193 86.0237L100.736 75.3226L97.4545 82.6046L97.6232 83.1671C97.6631 83.3002 97.6582 83.4426 97.6093 83.5726C97.5603 83.7026 97.47 83.8129 97.3523 83.8866C97.3523 83.8866 97.6596 85.8866 97.4544 85.8866C97.2493 85.8866 96.7365 86.1943 96.7365 86.1943C98.0151 90.1747 98.1868 93.9866 97.0142 97.5938L94.2455 97.468L92.4289 81.784L93.7622 73.2713L93.8648 71.6303L94.3263 71.6493L94.5613 70.9637L94.9929 69.7842L106.993 70.5021Z",
    fill: "url(#paint18_linear_4699_3876)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M107.17 71.0195L107.188 70.9938C108.164 69.6271 106.696 66.3427 106.475 65.8666L107.407 65.564L108.223 58.6622L108.82 56.278C109.044 55.3767 109.025 54.4318 108.764 53.5403C108.503 52.6488 108.009 51.8429 107.334 51.2052L105.955 49.9052L104.279 47.4258H101.577L100.651 49.1759C99.7524 49.3835 98.9554 49.8996 98.3986 50.6344C97.8418 51.3692 97.5603 52.2761 97.6034 53.1971L97.8133 57.787L96.9913 63.5019L96.9908 64.5361L95.5636 66.876L95.2527 68.3267C95.1241 68.4965 94.2749 69.6288 94.2749 69.9384C94.2749 69.9848 94.3092 70.0298 94.3828 70.0796C94.9615 70.4715 98.1602 71.2704 99.5759 70.7039C101.084 70.1009 107.078 71.0055 107.139 71.0147L107.17 71.0195Z",
    fill: "#FF9A27"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M102.579 46.6242C100.603 46.6242 99.0008 45.022 99.0008 43.0455C99.0008 41.069 100.603 39.4668 102.579 39.4668C104.556 39.4668 106.158 41.069 106.158 43.0455C106.158 45.022 104.556 46.6242 102.579 46.6242Z",
    fill: "#FFB6B6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8621 64.7116L96.6209 58.8536C96.6209 58.8536 97.6591 54.8202 98.8454 53.4434L101.495 54.3053L100.239 59.3532L94.593 65.9505C94.5723 66.1656 94.4953 66.3714 94.3697 66.5473C94.2441 66.7231 94.0745 66.8628 93.8778 66.9523C93.6811 67.0417 93.4643 67.0777 93.2492 67.0568C93.0341 67.0358 92.8284 66.9585 92.6527 66.8328C92.477 66.707 92.3375 66.5372 92.2483 66.3404C92.1591 66.1436 92.1233 65.9267 92.1445 65.7117C92.1657 65.4967 92.2432 65.291 92.3692 65.1154C92.4952 64.9399 92.6651 64.8006 92.8621 64.7116Z",
    fill: "#FFB6B6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M100.126 38.9146C100.382 38.907 100.294 38.4235 100.501 38.2693C100.502 38.2739 100.503 38.2786 100.504 38.2833C100.531 38.3877 100.591 38.4807 100.675 38.5485C100.759 38.6163 100.862 38.6554 100.97 38.66C101.078 38.6646 101.184 38.6345 101.274 38.5741C101.363 38.5136 101.431 38.4261 101.467 38.3243C101.501 38.2066 101.563 38.0989 101.648 38.0102C101.732 37.9214 101.837 37.8543 101.953 37.8145C101.966 38.2626 102.305 38.6515 102.709 38.845C103.113 39.0386 103.574 39.0708 104.023 39.0774C104.471 39.084 104.926 39.069 105.36 39.1787C105.795 39.2884 106.218 39.5463 106.403 39.9543C106.589 40.3623 106.457 40.9241 106.051 41.114C106.365 41.1157 106.632 41.3753 106.741 41.6704C106.83 41.9732 106.853 42.2916 106.809 42.6041C106.721 43.7614 106.505 45.0072 105.662 45.8053C105.02 46.4136 104.101 46.6586 103.216 46.6551C102.332 46.6515 102.487 46.5702 101.632 46.3444C101.632 46.3444 100.819 44.0135 101.024 43.7842C101.229 43.5549 101.399 43.2615 101.362 42.9563C101.325 42.6511 100.997 42.3777 100.712 42.4939C100.76 42.3716 100.796 42.3483 100.818 42.3545C100.804 42.3197 100.792 42.2842 100.781 42.2481C100.727 42.0643 100.631 41.8957 100.499 41.7564C100.368 41.6171 100.205 41.5109 100.025 41.4467C99.8428 41.3875 99.6468 41.3856 99.4635 41.4411C99.2801 41.4966 99.1181 41.6068 98.9993 41.7571C98.0628 40.8788 98.6438 38.9586 100.126 38.9146Z",
    fill: "url(#paint19_linear_4699_3876)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4699_3876",
    x1: 13.4272,
    y1: 2.85755,
    x2: 17.2769,
    y2: 2.85755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4699_3876",
    x1: 20.0759,
    y1: 2.85755,
    x2: 23.9256,
    y2: 2.85755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4699_3876",
    x1: 26.7251,
    y1: 2.85755,
    x2: 30.5747,
    y2: 2.85755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4699_3876",
    x1: 42.6921,
    y1: 49.6886,
    x2: 54.1991,
    y2: 49.6886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4699_3876",
    x1: 58.5735,
    y1: 49.6886,
    x2: 69.6729,
    y2: 49.6886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4699_3876",
    x1: 47.7871,
    y1: 27.2855,
    x2: 61.8955,
    y2: 27.2855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4699_3876",
    x1: 39.5317,
    y1: 52.3372,
    x2: 44.419,
    y2: 52.3372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4699_3876",
    x1: 65.447,
    y1: 51.5047,
    x2: 72.0527,
    y2: 51.5047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4699_3876",
    x1: 22.6692,
    y1: 63.1221,
    x2: 71.9338,
    y2: 63.1221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4699_3876",
    x1: 70.054,
    y1: 63.2522,
    x2: 73.8114,
    y2: 63.2522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4699_3876",
    x1: 42.0818,
    y1: 75.1645,
    x2: 44.378,
    y2: 75.1645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4699_3876",
    x1: 41.4556,
    y1: 75.2413,
    x2: 41.6643,
    y2: 75.2413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4699_3876",
    x1: 66.9221,
    y1: 75.4994,
    x2: 74.8546,
    y2: 75.4994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4699_3876",
    x1: 69.2195,
    y1: 75.1645,
    x2: 71.5157,
    y2: 75.1645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4699_3876",
    x1: 71.9331,
    y1: 75.2413,
    x2: 72.1419,
    y2: 75.2413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4699_3876",
    x1: 11.2332,
    y1: 112.867,
    x2: 18.2009,
    y2: 112.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4699_3876",
    x1: 1.9209,
    y1: 92.2862,
    x2: 20.249,
    y2: 92.2862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4699_3876",
    x1: 2.15112,
    y1: 38.8756,
    x2: 16.6019,
    y2: 38.8756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4699_3876",
    x1: 108.844,
    y1: 85.4112,
    x2: 92.4289,
    y2: 85.4112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4699_3876",
    x1: 106.831,
    y1: 42.7822,
    x2: 98.5457,
    y2: 42.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCourses);
export default __webpack_public_path__ + "static/media/VideoCourses.5b8d8d3d22788b139c7a62a1bcde9fd7.svg";
export { ForwardRef as ReactComponent };